import { GroupId } from '../../typings/groups';
import { AdditionalTargetingField, RestInternalGroupField } from '../../typings/internalGroups';
import { EditPageBackToFrontErrorMapper } from '../EditPageBackToFrontErrorMapper/EditPageBackToFrontErrorMapper';

import { groupsTextErrorMapper } from './GroupEditErrorsTextMapper/GroupEditErrorsTextMapper';

const INDEX = '__INDEX__';

export const createTextGroupAddHandleErrorMapper = (groupIds: Array<GroupId>): EditPageBackToFrontErrorMapper =>
    new EditPageBackToFrontErrorMapper(
        'groups',
        {
            addItems: [
                {
                    serverPath: ['adGroupName'],
                    clientPath: ['name']
                },
                {
                    serverPath: ['adGroupMinusKeywords'],
                    clientPath: ['minusKeywords']
                },
                {
                    serverPath: ['adGroupMinusKeywords', INDEX],
                    clientPath: ['minusKeywords']
                },
                {
                    serverPath: ['phrase'],
                    clientPath: ['keywords']
                },
                {
                    serverPath: ['keywords', INDEX],
                    clientPath: ['keywords']
                },
                {
                    serverPath: ['regionIds'],
                    clientPath: ['regionIds']
                },
                {
                    serverPath: ['libraryMinusKeywordsIds', INDEX],
                    clientPath: ['libraryMinusKeywordsIds']
                },
                {
                    serverPath: ['targetInterests', INDEX],
                    clientPath: ['retargeting']
                },
                {
                    serverPath: ['targetInterests', INDEX, 'retargetingConditionId'],
                    clientPath: ['retargeting']
                },
                {
                    serverPath: ['retargetingCondition', 'name'],
                    clientPath: ['retargetingConditionName']
                },
                {
                    serverPath: ['pageGroupTags', INDEX],
                    clientPath: ['pageGroupTags']
                },
                {
                    serverPath: ['pageGroupTags'],
                    clientPath: ['pageGroupTags']
                },
                {
                    serverPath: ['targetTags', INDEX],
                    clientPath: ['targetTags']
                },
                {
                    serverPath: ['targetTags'],
                    clientPath: ['targetTags']
                }
            ]
        },
        groupIds,
        groupsTextErrorMapper,
        INDEX
    );

export const createTextGroupUpdateHandleErrorMapper = (groupIds: Array<GroupId>): EditPageBackToFrontErrorMapper =>
    new EditPageBackToFrontErrorMapper(
        'groups',
        {
            updateAdGroupItems: [
                {
                    serverPath: ['adGroupName'],
                    clientPath: ['name']
                },
                {
                    serverPath: ['adGroupMinusKeywords'],
                    clientPath: ['minusKeywords']
                },
                {
                    serverPath: ['adGroupMinusKeywords', INDEX],
                    clientPath: ['minusKeywords']
                },
                {
                    serverPath: ['keywords', INDEX, 'phrase'],
                    clientPath: ['keywords']
                },
                {
                    serverPath: ['keywords', INDEX],
                    clientPath: ['keywords']
                },
                {
                    serverPath: ['regionIds'],
                    clientPath: ['regionIds']
                },
                {
                    serverPath: ['libraryMinusKeywordsIds', INDEX],
                    clientPath: ['libraryMinusKeywordsIds']
                },
                {
                    serverPath: ['targetInterests', INDEX],
                    clientPath: ['retargeting']
                },
                {
                    serverPath: ['targetInterests', INDEX, 'retargetingConditionId'],
                    clientPath: ['retargeting']
                },
                {
                    serverPath: ['retargetingCondition', 'name'],
                    clientPath: ['retargetingConditionName']
                },
                {
                    serverPath: ['pageGroupTags', INDEX],
                    clientPath: ['pageGroupTags']
                },
                {
                    serverPath: ['pageGroupTags'],
                    clientPath: ['pageGroupTags']
                },
                {
                    serverPath: ['targetTags', INDEX],
                    clientPath: ['targetTags']
                },
                {
                    serverPath: ['targetTags'],
                    clientPath: ['targetTags']
                }
            ]
        },
        groupIds,
        groupsTextErrorMapper,
        INDEX
    );

export const createMcBannerGroupUpdateHandleErrorMapper = (groupIds: Array<GroupId>): EditPageBackToFrontErrorMapper =>
    new EditPageBackToFrontErrorMapper(
        'groups',
        {
            updateItems: [
                {
                    serverPath: ['adGroupName'],
                    clientPath: ['name']
                },
                {
                    serverPath: ['adGroupMinusKeywords'],
                    clientPath: ['minusKeywords']
                },
                {
                    serverPath: ['adGroupMinusKeywords', INDEX],
                    clientPath: ['minusKeywords']
                },
                {
                    serverPath: ['keywords', INDEX, 'phrase'],
                    clientPath: ['keywords']
                },
                {
                    serverPath: ['keywords', INDEX],
                    clientPath: ['keywords']
                },
                {
                    serverPath: ['regionIds'],
                    clientPath: ['regionIds']
                },
                {
                    serverPath: ['libraryMinusKeywordsIds', INDEX],
                    clientPath: ['libraryMinusKeywordsIds']
                },
                {
                    serverPath: ['pageGroupTags', INDEX],
                    clientPath: ['pageGroupTags']
                },
                {
                    serverPath: ['pageGroupTags'],
                    clientPath: ['pageGroupTags']
                },
                {
                    serverPath: ['targetTags', INDEX],
                    clientPath: ['targetTags']
                },
                {
                    serverPath: ['targetTags'],
                    clientPath: ['targetTags']
                }
            ]
        },
        groupIds,
        groupsTextErrorMapper,
        INDEX
    );

export const createSmartGroupUpdateHandleErrorMapper = (groupIds: Array<GroupId>): EditPageBackToFrontErrorMapper =>
    new EditPageBackToFrontErrorMapper(
        'groups',
        {
            updateItems: [
                {
                    serverPath: ['adGroupName'],
                    clientPath: ['name']
                },
                {
                    serverPath: ['minusKeywords'],
                    clientPath: ['minusKeywords']
                },
                {
                    serverPath: ['minusKeywords', INDEX],
                    clientPath: ['minusKeywords']
                },
                {
                    serverPath: ['regionIds'],
                    clientPath: ['regionIds']
                },
                {
                    serverPath: ['level'],
                    clientPath: ['level']
                },
                {
                    serverPath: ['pageGroupTags', INDEX],
                    clientPath: ['pageGroupTags']
                },
                {
                    serverPath: ['pageGroupTags'],
                    clientPath: ['pageGroupTags']
                },
                {
                    serverPath: ['targetTags', INDEX],
                    clientPath: ['targetTags']
                },
                {
                    serverPath: ['targetTags'],
                    clientPath: ['targetTags']
                }
            ]
        },
        groupIds,
        groupsTextErrorMapper,
        INDEX
    );

export const createSmartGroupAddHandleErrorMapper = (groupId: GroupId): EditPageBackToFrontErrorMapper =>
    new EditPageBackToFrontErrorMapper(
        'groups',
        {
            addItems: [
                {
                    serverPath: ['adGroupName'],
                    clientPath: ['name']
                },
                {
                    serverPath: ['feedId'],
                    clientPath: ['feedId']
                }
            ]
        },
        [groupId],
        groupsTextErrorMapper,
        INDEX
    );

export const createCpmGroupUpdateHandleErrorMapper = (groupIds: Array<GroupId>): EditPageBackToFrontErrorMapper =>
    new EditPageBackToFrontErrorMapper(
        'groups',
        {
            updateCpmAdGroupItems: [
                {
                    serverPath: ['adGroupName'],
                    clientPath: ['name']
                },
                {
                    serverPath: ['name'],
                    clientPath: ['name']
                },
                {
                    serverPath: ['pageBlocks'],
                    clientPath: ['pageBlocks']
                },
                {
                    serverPath: ['pageBlocks', INDEX, 'pageId'],
                    clientPath: ['pageBlocks']
                },
                {
                    serverPath: ['adGroupMinusKeywords'],
                    clientPath: ['minusKeywords']
                },
                {
                    serverPath: ['adGroupMinusKeywords', INDEX],
                    clientPath: ['minusKeywords']
                },
                {
                    serverPath: ['keywords', INDEX, 'phrase'],
                    clientPath: ['keywords']
                },
                {
                    serverPath: ['keywords', INDEX],
                    clientPath: ['keywords']
                },
                {
                    serverPath: ['keywords'],
                    clientPath: ['keywords']
                },
                {
                    serverPath: ['regionIds'],
                    clientPath: ['regionIds']
                },
                {
                    serverPath: ['libraryMinusKeywordsIds'],
                    clientPath: ['libraryMinusKeywordsIds']
                },
                {
                    serverPath: ['targetInterests', INDEX],
                    clientPath: ['retargeting']
                },
                {
                    serverPath: ['targetInterests', INDEX, 'retargetingConditionId'],
                    clientPath: ['retargeting']
                },
                {
                    serverPath: ['retargetingCondition', 'name'],
                    clientPath: ['retargetingConditionName']
                },
                {
                    serverPath: ['retargetingCondition', 'conditionRules', INDEX, 'goals', INDEX, 'id'],
                    clientPath: ['retargetingCondition']
                },
                {
                    serverPath: ['retargetingCondition', 'conditionRules'],
                    clientPath: ['retargetingCondition']
                },
                {
                    serverPath: ['generalPrice'],
                    clientPath: ['generalRate']
                },
                {
                    serverPath: ['pageGroupTags', INDEX],
                    clientPath: ['pageGroupTags']
                },
                {
                    serverPath: ['pageGroupTags'],
                    clientPath: ['pageGroupTags']
                },
                {
                    serverPath: ['targetTags', INDEX],
                    clientPath: ['targetTags']
                },
                {
                    serverPath: ['targetTags'],
                    clientPath: ['targetTags']
                }
            ]
        },
        groupIds,
        groupsTextErrorMapper,
        INDEX
    );

const internalGroupErrorPaths = [
    {
        serverPath: ['adGroupName'],
        clientPath: [RestInternalGroupField.NAME]
    },
    {
        serverPath: ['name'],
        clientPath: ['name']
    },
    {
        serverPath: ['regionIds'],
        clientPath: ['regionIds']
    },
    {
        serverPath: [AdditionalTargetingField.YANDEX_UIDS, 'value'],
        clientPath: [AdditionalTargetingField.YANDEX_UIDS]
    },
    {
        serverPath: [AdditionalTargetingField.MOBILE_INSTALLED_APPS, 'value'],
        clientPath: [AdditionalTargetingField.MOBILE_INSTALLED_APPS]
    },
    {
        serverPath: [AdditionalTargetingField.INTERFACE_LANGS, 'value'],
        clientPath: [AdditionalTargetingField.INTERFACE_LANGS]
    },
    {
        serverPath: [AdditionalTargetingField.OS_FAMILIES, 'value'],
        clientPath: [AdditionalTargetingField.OS_FAMILIES]
    },
    {
        serverPath: [AdditionalTargetingField.OS_NAMES, 'value'],
        clientPath: [AdditionalTargetingField.OS_NAMES]
    },
    {
        serverPath: [AdditionalTargetingField.QUERY_REFERERS, 'value'],
        clientPath: [AdditionalTargetingField.QUERY_REFERERS]
    },
    {
        serverPath: [AdditionalTargetingField.QUERY_OPTIONS, 'value'],
        clientPath: [AdditionalTargetingField.QUERY_OPTIONS]
    },
    {
        serverPath: [AdditionalTargetingField.BROWSER_ENGINES, 'value'],
        clientPath: [AdditionalTargetingField.BROWSER_ENGINES]
    },
    {
        serverPath: [AdditionalTargetingField.BROWSER_NAMES, 'value'],
        clientPath: [AdditionalTargetingField.BROWSER_NAMES]
    },
    {
        serverPath: [AdditionalTargetingField.DEVICE_NAMES, 'value'],
        clientPath: [AdditionalTargetingField.DEVICE_NAMES]
    },
    {
        serverPath: [AdditionalTargetingField.DEVICE_VENDORS, 'value'],
        clientPath: [AdditionalTargetingField.DEVICE_VENDORS]
    },
    {
        serverPath: [AdditionalTargetingField.DESKTOP_INSTALLED_APPS, 'value'],
        clientPath: [AdditionalTargetingField.DESKTOP_INSTALLED_APPS]
    },
    {
        serverPath: [AdditionalTargetingField.SHOW_DATES, 'value'],
        clientPath: [AdditionalTargetingField.SHOW_DATES]
    },
    {
        serverPath: [AdditionalTargetingField.YS_COOKIES, 'value'],
        clientPath: [AdditionalTargetingField.YS_COOKIES]
    },
    {
        serverPath: [AdditionalTargetingField.CLID_TYPES, 'value'],
        clientPath: [AdditionalTargetingField.CLID_TYPES]
    },
    {
        serverPath: [AdditionalTargetingField.CLIDS, 'value'],
        clientPath: [AdditionalTargetingField.CLIDS]
    },
    {
        serverPath: [AdditionalTargetingField.TEST_IDS, 'value'],
        clientPath: [AdditionalTargetingField.TEST_IDS]
    },
    {
        serverPath: [AdditionalTargetingField.USER_AGENTS, 'value'],
        clientPath: [AdditionalTargetingField.USER_AGENTS]
    },
    {
        serverPath: [RestInternalGroupField.FINISH_TIME],
        clientPath: [RestInternalGroupField.FINISH_TIME]
    },
    {
        serverPath: [RestInternalGroupField.LEVEL],
        clientPath: [RestInternalGroupField.LEVEL]
    }
];

export const createInternalGroupUpdateHandleErrorMapper = (groupIds: Array<GroupId>): EditPageBackToFrontErrorMapper =>
    new EditPageBackToFrontErrorMapper(
        'groups',
        {
            updateItems: internalGroupErrorPaths
        },
        groupIds,
        groupsTextErrorMapper,
        INDEX
    );

export const createInternalGroupAddHandleErrorMapper = (groupIds: Array<GroupId>): EditPageBackToFrontErrorMapper =>
    new EditPageBackToFrontErrorMapper(
        'groups',
        {
            addItems: internalGroupErrorPaths
        },
        groupIds,
        groupsTextErrorMapper,
        INDEX
    );

export const createContentPromotionGroupAddHandleErrorMapper = (
    groupIds: Array<GroupId>
): EditPageBackToFrontErrorMapper => {
    const contentPromotionGroupErrorPaths = [
        {
            serverPath: ['adGroupName'],
            clientPath: ['name']
        },
        {
            serverPath: ['adGroupMinusKeywords'],
            clientPath: ['minusKeywords']
        },
        {
            serverPath: ['adGroupMinusKeywords', INDEX],
            clientPath: ['minusKeywords']
        },
        {
            serverPath: ['keywords', INDEX, 'phrase'],
            clientPath: ['keywords']
        },
        {
            serverPath: ['keywords', INDEX],
            clientPath: ['keywords']
        },
        {
            serverPath: ['regionIds'],
            clientPath: ['regionIds']
        },
        {
            serverPath: ['libraryMinusKeywordsIds', INDEX],
            clientPath: ['libraryMinusKeywordsIds']
        },
        {
            serverPath: ['pageGroupTags', INDEX],
            clientPath: ['pageGroupTags']
        },
        {
            serverPath: ['pageGroupTags'],
            clientPath: ['pageGroupTags']
        },
        {
            serverPath: ['targetTags', INDEX],
            clientPath: ['targetTags']
        },
        {
            serverPath: ['targetTags'],
            clientPath: ['targetTags']
        },
        {
            serverPath: ['generalPrice'],
            clientPath: ['generalRate']
        }
    ];

    return new EditPageBackToFrontErrorMapper(
        'groups',
        {
            addItems: contentPromotionGroupErrorPaths,
            updateItems: contentPromotionGroupErrorPaths
        },
        groupIds,
        groupsTextErrorMapper,
        INDEX
    );
};
